module.exports = __webpack_public_path__ + "img/logo.e29d2ecb.jpg";